import React from "react";
import styles from "../../../assets/stylesheets/blog/FarmmodeBlogDetail.module.css";
import MainImg from "../../../assets/img/blog/25maple/Main25MapleFarm.webp"; 
import Elliott from "../../../assets/img/blog/25maple/Elliott.webp"; 
import Elsies from "../../../assets/img/blog/25maple/Elsies.webp"; 
import FortRose from "../../../assets/img/blog/25maple/FortRose.webp"; 
import Hogans from "../../../assets/img/blog/25maple/Hogans.webp"; 
import Muskoka from "../../../assets/img/blog/25maple/Muskoka.avif"; 
import Richardsons from "../../../assets/img/blog/25maple/Richardsons.webp"; 


const MAPLE_REGIONS = [
  {
    id: "gta",
    region: "Toronto GTA",
    farms: [
      {
        name: "Elliott Tree Farm - Maple Syrup Experience 2025",
        img: Elliott,
        description: "Enjoy a pancake brunch and explore the self-guided maple syrup tours at this charming farm.",
        location: "9467 Erin East Garafraxa Townline, Hillsburgh, ON",
        website: "Elliott Tree Farm",
        webUrl: "https://www.elliotttreefarm.ca/",
        dates: "February 15 - April 6, 2025"
      },
      {
        name: "Pefferlaw Creek Farm - Maple Festival 2025",
        description: "Visit the sugar bush for a tapping tour, sugar shack tour, and fresh maple taffy, with a delicious pancake meal featuring local sausages and live music on select dates.",
        location: "12300 Concession 6, Uxbridge, ON L9P 1R2",
        website: "Pefferlaw Creek Farm",
        webUrl: "https://www.pcfarm.ca/",
        dates: "Weekends from March 8 - April 19, 2025"
      },
      {
        name: "Drysdale’s Tree Farm - Maple Syrup Festival 2025",
        description: "Experience maple taffy on snow, horse-drawn wagon rides, bonfires, face painting, and a delicious pancake lunch at this family-friendly farm.",
        location: "6635 Simcoe County Rd 56, Egbert, ON L0L 1N0",
        website: "Drysdale’s Tree Farm",
        webUrl: "https://www.drysdales.ca/",
        dates: "March 23th - 24th, 2025"
      },
      {
        name: "Brooks Farms - Maplefest 2025",
        description: "Take a sugar bush tour, roast marshmallows, enjoy a maple syrup tasting, and visit the farm market for fresh produce and baked goods.",
        location: "122 Ashworth Road, Mount Albert, ON L0G 1M0",
        website: "Brooks Farms",
        webUrl: "https://www.brooksfarms.com/",
        dates: "March 2025 (Check website for exact dates)"
      },
      {
        name: "Breedon’s Maple Syrup - Maple Farm Experience 2025",
        description: "This family-owned farm has been producing syrup since 1995, offering educational tours on modern and traditional syrup-making methods, along with a farm store selling maple products.",
        location: "3662 Concession 3, Adjala Township, Alliston, ON",
        website: "Breedon’s Maple Syrup",
        webUrl: "https://www.breedonsmaplesyrup.ca/",
        dates: "Saturdays in March & April 2025"
      },
      {
        name: "Kortright Centre for Conservation - Maple Syrup Festival 2025",
        description: "Enjoy family-friendly activities and maple syrup demonstrations on weekends and March Break, plus an evening guided tour to explore the history of maple syrup.",
        location: "9550 Pine Valley Dr, Woodbridge, ON L4L 1A6",
        website: "Kortright Centre for Conservation",
        webUrl: "https://kortright.ca/",
        dates: "March 8 - April 6, 2025"
      },
      {
        name: "Bruce’s Mill Conservation Area - Maple Syrup Festival 2025",
        description: "Featuring tree-tapping demonstrations, maple syrup making, and family-friendly activities, including a special evening program on select dates.",
        location: "3291 Stouffville Rd, Whitchurch-Stouffville, ON L4A 7X5",
        website: "Bruce's Mill Conservation Area",
        webUrl: "https://trca.ca/parks/bruces-mill-conservation-area/",
        dates: "March 8 - April 6, 2025"
      },
      {
        name: "Sandy Flats Sugar Bush - Maple Farm Experience 2025",
        description: "Enjoy a fun-filled experience with pancake breakfasts, sugar shack tours, and maple syrup tastings at this iconic sugar bush.",
        location: "500 Concession Road 3 West, Warkworth, ON",
        website: "Sandy Flats Sugar Bush",
        webUrl: "https://sandyflatsugarbush.com/",
        dates: "March 13-16 | March 22 & 23 | March 29 & 30"
      }
    ]
  },
  {
    id: "sw",
    region: "Southwestern Ontario",
    farms: [
      {
        name: "Fort Rose Maple Company - Maple Syrup Festival 2025",
        img: FortRose,
        description: "A family-run farm with over 8,000 taps, offering wagon rides and a buffet-style pancake house for a true maple experience.",
        location: "27382 Coldstream Rd, Parkhill, ON",
        website: "Fort Rose Maple Company",
        webUrl: "https://fortrose.ca/",
        dates: "Weekends from February 22 - March 30, 2025 | March Break (March 10-14, 2025)"
      },
      {
        name: "McLauhlan Family Pancake House - Traditional Maple Experience",
        description: "Enjoy fresh maple syrup, a nature trail, and an authentic traditional syrup-making process in a cozy setting.",
        location: "10279 Lamont Dr, Komoka, ON",
        website: "McLauhlan Family Pancake House",
        webUrl: "https://www.mclauhlan.ca/",
        dates: "February - April 2025"
      },
      {
        name: "Blyth Creek Maple Farm - Maple Tours & Outdoor Activities",
        description: "More than just maple syrup! Enjoy maple tours, a pancake house, farm animals, tractor rides, and even archery for a fun-filled day.",
        location: "42232 Moncrieff Rd., Blyth, ON",
        website: "Blyth Creek Maple Farm",
        webUrl: "https://blythcreekmaplefarm.com/",
        dates: "March - April 2025 | Maple Weekend: April 5-6, 2025"
      },
      {
        name: "Hoover’s Maple Syrup - Family-Owned Sugar Bush",
        description: "A traditional maple farm experience with syrup-making demonstrations, maple treats, and a warm, welcoming atmosphere.",
        location: "5896 Line 78, Atwood, ON",
        website: "Hoover’s Maple Syrup",
        webUrl: "https://hooversmaplesyrup.com/",
        dates: "Family Day Weekend: Feb 15-17 | Sat & Sun: Feb 22 - Apr 21, 2025"
      },
      {
        name: "Rock Maple Lodge - Rustic Maple Experience",
        description: "A quaint sugar bush retreat where you can enjoy a relaxing maple experience in the heart of nature.",
        location: "2491 Norman Rd, Branchton, ON",
        website: "Rock Maple Lodge",
        webUrl: "https://www.rockmaplelodge.ca/",
        dates: "March 2025 | Maple Weekend: April 5-6, 2025"
      },
      {
        name: "Kinsmen Fanshawe Sugar Bush - Classic Sugar Bush Experience",
        description: "A quaint sugar bush retreat where you can enjoy a relaxing maple experience in the heart of nature.",
        location: "2491 Norman Rd, Branchton, ON",
        website: "Kinsmen Fanshawe Sugar Bush",
        webUrl: "https://kinsmen-fanshawe-sugar-bush.com/",
        dates: "Family Day Weekend: Feb 15-17, 2025 | Weekends: Feb 22 - Mar 16, 2025 | March Break: Mar 10-14, 2025"
      }
    ]
  },
  {
    id: "niagara",
    region: "Niagara Region",
    farms: [
      {
        name: "Richardson’s Farm & Market - Sugar Bush & Pancake Experience",
        img: Richardsons,
        description: "Enjoy guided sugar bush tours, fresh farm produce, and delicious pancakes drizzled with maple syrup.",
        location: "131 River Road, Dunnville, ON",
        website: "Richardson’s Farm & Market",
        webUrl: "https://richardsonsfarm.com/",
        dates: "March 8, March 11-15, March 29, 2025"
      },
      {
        name: "Agape Valley Sugar Bush - Family-Friendly Maple Farm",
        description: "Take a hayride shuttle to the sugar bush, enjoy a delicious pancake meal, and explore the maple syrup-making process.",
        location: "392 Kilman Road, Ridgeville, ON",
        website: "Agape Valley Sugar Bush",
        webUrl: "https://agapevalley.ca/",
        dates: "Every Saturday in March & March Break (March 10-14, 2025)"
      },
      {
        name: "White Meadows Farms - Sugar Bush Trek & Maple Treats",
        description: "Experience a self-guided Sugar Bush Trek, make maple taffy in the snow, and visit their farm store for fresh maple products.",
        location: "2519 Effingham Street, Pelham, ON",
        website: "White Meadows Farms",
        webUrl: "https://whitemeadowsfarms.com/",
        dates: "March 1 - April 13, 2025"
      }
    ]
  },
  {
    id: "barrie",
    region: "Barrie & Simcoe County",
    farms: [
      {
        name: "Elsie’s Creek Farm - Maple Syrup Experience 2025",
        img: Elsies,
        description: "A family-run farm producing high-quality maple syrup since 1999, now with over 1,200 taps. Enjoy self-guided tours of the sugar bush and watch the evaporator in action (weather permitting).",
        location: "4279 Line 5 North, Coldwater, ON",
        website: "Elsie’s Creek Farm",
        webUrl: "https://elsiescreekfarm.ca/"
      },
      {
        name: "Hewitt’s Farm Market & Bakery - Maple Treats & More",
        description: "Visit this local farm market to enjoy a variety of maple goodies, including Hewitt’s Pure Maple Syrup, maple pecan muffins, fudge, barbecue sauces, bacon, and sausages.",
        location: "3331 Town Line, Coldwater, ON L0K 1E0",
        website: "Hewitt’s Farm Market & Bakery",
        webUrl: "https://hewittsfarmmarket.com/"
      },
      {
        name: "Hutchinson Maple Syrup - Sugar Shack Tours & Trails",
        description: "Experience maple syrup production from tree to bottle. Enjoy self-guided walking trails, a tour of the sugar shack, and a variety of maple products available for purchase.",
        location: "2217 5 Line North, Oro-Medonte, ON L0L 2E0",
        website: "Hutchinson Maple Syrup",
        webUrl: "https://hutchinsonmaplesyrup.com/"
      },
      {
        name: "Maple Grove Syrup - Traditional Sugar Bush Experience",
        description: "A family-owned sugar bush that has been producing maple syrup for generations. Enjoy self-guided tours, sugar camp visits, taffy on snow, and syrup-making demonstrations.",
        location: "493 Oro-Medonte Line 14 South, Oro-Medonte, ON L3V 8J3",
        website: "Maple Grove Syrup",
        webUrl: "https://maplegrovesyrup.ca/"
      },
      {
        name: "Shaws Maple Syrup - Historic Pancake House & Sugar Bush",
        description: "A 120-year-old family-run farm, Shaws offers self-guided sugar bush tours and a chance to see how maple syrup production has evolved over time. Their Pancake House serves delicious maple-infused treats.",
        location: "2448 Burnside Line, Severn, ON L3V 0W1",
        website: "Shaws Maple Syrup",
        webUrl: "https://shawsmaplesyrup.com/"
      },
      {
        name: "Windlee Farms Maple Syrup - Traditional Wood-Fired Syrup",
        description: "A family-run farm for over 25 years, Windlee Farms crafts maple syrup the traditional way, using a wood-fired evaporator and a modern tubing system with 500+ taps.",
        location: "10 Baseline Road North, Tiny, ON L4R 0E3",
        website: "Windlee Farms Maple Syrup",
        webUrl: "https://windleefarms.ca/"
      }
    ]
  },
  {
    id: "muskoka",
    region: "Muskoka",
    farms: [
      {
        name: "Muskoka Maple Trail - A Sweet Culinary Adventure",
        img: Muskoka,
        description: "Explore a self-guided maple-themed culinary tour, featuring maple-infused treats, drinks, and immersive experiences at multiple locations in Muskoka.",
        location: "Various locations, including Hubbert’s Maple & Muskoka Lakes Farm & Winery",
        website: "Muskoka Maple Trail",
        webUrl: "https://www.discovermuskoka.ca/muskoka-maple-trail/",
        dates: "March 7 - April 26, 2025"
      },
      {
        name: "Sugarbush Hill Maple Farm - Heritage Sugar Shack & Tours",
        description: "Explore a self-guided maple-themed culinary tour, featuring maple-infused treats, drinks, and immersive experiences at multiple locations in Muskoka.",
        location: "2389 Muskoka Road 10, Huntsville, ON",
        website: "Sugarbush Hill Maple Farm",
        webUrl: "https://sugarbushhill.com/",
        dates: "March 9 - April 7, 2025"
      }
    ]
  },
  {
    id: "northern",
    region: "Northern Ontario",
    farms: [
      {
        name: "Hogan’s Homestead - Northern Ontario Maple Experience",
        img: Hogans,
        description: "A family-owned maple farm in Northern Ontario offering fresh maple syrup and farm experiences in a scenic setting.",
        location: "1157 Thielman Road, Goulais River, ON",
        website: "Hogan’s Homestead",
        webUrl: "https://hoganshomestead.ca/",
        dates: "March 3 - April 30, 2025"
      }
    ]
  }

];

export default function MapleSyrup25() {
  return (
    <div className={styles.page}>
      {/* Top meta like blogTO */}
      <div className={styles["top-meta"]}>
        {/* <span className={styles["category-name"]}>Travel</span>
        <span className={styles["sep"]}>•</span>
        <span>FarmCiti Team</span>
        <span className={styles["sep"]}>•</span>
        <span>February 11, 2025</span> */}
      </div>

      {/* Main Title */}
      <h1 className={styles["title"]}>25 Must-Visit Maple Syrup Farms Near Toronto (2025 Guide)</h1>

      {/* Hero Image */}
      <div className={styles["hero-wrap"]}>
        <img
          className={styles["hero"]}
          src={MainImg}
          alt="Maple Syrup Festival"
        />
      </div>

      <div className={styles["lead-section"]}>
        <p><strong>Ontario’s sweetest season has arrived!</strong><br />
        As winter melts away and the first hints of spring appear, maple syrup farms and sugar shacks across the GTA come to life, offering a delicious and unforgettable experience for all ages. Whether you’re drawn in by the sight of sap dripping from sugar maple trees, the rich aroma of boiling syrup, or the irresistible taste of warm maple treats, there’s no better way to welcome the season than with a classic Canadian maple adventure.</p>
        
        <p>From tree-tapping and sugarbush tours to rustic pancake houses and bustling maple festivals, there’s something for families, couples, and adventure-seekers alike. Step into the woods, watch the magic of maple syrup production firsthand, and indulge in the sweetest flavors of spring.</p>
        
        <p>Ready to explore? We’ve rounded up 25 of the best maple farms, sugar shacks, and pancake houses near Toronto where you can experience the magic of Maple Season 2025.</p>

        <p><strong>🗓 Maple Season:</strong> Early March to Mid/Late April 2025<br />
        Grab your boots, bring your appetite, and let’s dive into Ontario’s most delicious seasonal tradition!</p>
      </div>

      <div className={styles["jump-links"]}>
        {MAPLE_REGIONS.map((region, idx) => (
          <React.Fragment key={region.id}>
            <a href={`#${region.id}`}>{region.region}</a>
            {idx < MAPLE_REGIONS.length - 1 && <span> | </span>}
          </React.Fragment>
        ))}
      </div>

      {MAPLE_REGIONS.map((region) => (
        <div key={region.id} id={region.id}>
          <h2 className={styles["region-title"]}>{region.region}</h2>
          <hr className={styles["region-divider"]} />
          
          {region.farms.map((farm, fIdx) => (
            <div key={fIdx} className={styles["farm-section"]}>
              <h3 className={styles["farm-name"]}>{farm.name}</h3>
              <hr className={styles["region-divider"]} />
              
              {farm.img && <img src={farm.img} alt={farm.name} className={styles["farm-image"]} />}
              
              <div className={styles["farm-description"]}>
                <p>{farm.description}</p>
              </div>

              <div className={styles["event-details-title"]}>Event Details:</div>
              <ul className={styles["details-list"]}>
                <li className={styles["details-item"]}>
                    <span className={styles["details-label"]}>Location:</span> {farm.location}
                </li>
                {farm.dates && (
                    <li className={styles["details-item"]}>
                    <span className={styles["details-label"]}>Dates:</span> {farm.dates}
                    </li>
                )}
                {farm.website && (
                  <li className={styles["details-item"]}>
                    <span className={styles["details-label"]}>Website:</span><br />
                    <a href={farm.webUrl} className={styles["website-link"]} target="_blank" rel="noopener noreferrer">
                      {farm.website}
                    </a>
                  </li>
                )}
              </ul>
              <hr className={styles["farm-divider"]} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
